import React, { Suspense } from 'react';
import { AuthProvider } from './hooks/contexts/AuthContext';
import { RouterProvider } from 'react-router-dom';
import PageLoading from './PageLoading';
import { useMediaQuery } from '@mui/system';
import ApiDispatch from './apiCalls/ApiDispatch';

// mobile Device Router
import { mobileRouter } from './routes/mobileRoutes';

// large Device Router
import { router } from './routes';

function App() {
  const routes = useMediaQuery('(max-width:970px)') ? mobileRouter : router;
  return (
    <React.Fragment>
      <AuthProvider>
        <Suspense fallback={<PageLoading />}>
          <RouterProvider router={routes} />
        </Suspense>
      </AuthProvider>
    </React.Fragment>
  );
}

export default App;
